// 환경 변수에서 API 엔드포인트 설정 가져오기
const apiEndpoint = process.env.VUE_APP_API_ENDPOINT || "https://localhost:3000/api/v1";

// 모든 API 엔드포인트 설정
export const apiEndpoints = {
  api_captcha: `${apiEndpoint}/auth/captcha`,
  api_login: `${apiEndpoint}/auth/login`,
  api_register: `${apiEndpoint}/auth/register`,
  api_logout: `${apiEndpoint}/auth/logout`,
  api_settings: `${apiEndpoint}/settings`,
  api_lobbyList: `${apiEndpoint}/game/lobby`,
  api_gamePlay: `${apiEndpoint}/game/play`,
  api_gameList: `${apiEndpoint}/game/list`,
  api_myInfo: `${apiEndpoint}/users/me`,
  api_refreshToken: `${apiEndpoint}/auth/refresh`,
  api_updateMyInfo: `${apiEndpoint}/users/me`,
  api_deposit: `${apiEndpoint}/users/me/banking`,
  api_withdraw: `${apiEndpoint}/users/me/banking`,
  api_bankingHistory: `${apiEndpoint}/users/me/banking/history`,
  api_bettingHistory: `${apiEndpoint}/users/me/betting/history`,
  api_notices: `${apiEndpoint}/system/notices`,
  api_inquiries: `${apiEndpoint}/system/inquiries`,
  api_writeNotice: `${apiEndpoint}/system/notices`,
  api_writeInquiry: `${apiEndpoint}/system/inquiries`,
  api_pointToChip: `${apiEndpoint}/users/me/point-to-chip`,

  api_gamecasinoNew: apiEndpoint + "list-game-new",
  api_gamecasinoHot: apiEndpoint + "list-game-hot",
  api_listnotifilist: apiEndpoint + "noticelist",
  api_sendchat: apiEndpoint + "chat/client-send",
  api_listFaq: apiEndpoint + "faq/list-faq",
};

export function setAccessToken(accessToken) {
  sessionStorage.setItem("accessToken", accessToken);
}

export function getAccessToken() {
  return sessionStorage.getItem("accessToken");
}

export function initApi(app, axios) {
  axios.interceptors.request.use(
    (config) => {
      config.withCredentials = true
      const accessToken = getAccessToken()
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  for (const [key, val] of Object.entries(apiEndpoints)) {
    app.config.globalProperties[key] = val
  }
}
